import {
  Toast,
  CloseToast,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
  ToastProps,
} from './Toast';
import { useToast, AddToastParams } from './useToast';
import { CircleAlertIcon, CircleCheckIcon, InfoIcon, WarningIcon } from 'components/Blocks/Icons';

const icons: Record<NonNullable<ToastProps['type']>, typeof InfoIcon> = {
  info: InfoIcon,
  error: CircleAlertIcon,
  success: CircleCheckIcon,
  background: InfoIcon,
  primary: InfoIcon,
  warning: WarningIcon,
};

function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, type = 'info', ...props }) {
        const Icon = icons[type];

        return (
          <Toast key={id} type={type} {...props}>
            <Icon />

            <div className="grid gap-0">
              <ToastTitle>{title}</ToastTitle>

              {description && <ToastDescription>{description}</ToastDescription>}
            </div>

            <CloseToast type={type} />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}

export { useToast, Toaster, type AddToastParams };
